// extracted by mini-css-extract-plugin
module.exports = {"StripeElement":"CardElementWithFormik-module--StripeElement--31z2-"};